import type { AgentMessage } from '@/components/ai-agent/AgentMessages';
import type { AssistantTableExportRequest } from '@/services/aiAgent.service';

export function findLastExportableTable(messages: AgentMessage[]): AssistantTableExportRequest | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (m.role !== 'tool' || !m.data || typeof m.data !== 'object' || Array.isArray(m.data)) continue;
    const d = m.data as Record<string, unknown>;
    const table = d.dataTable;
    if (!table || typeof table !== 'object' || Array.isArray(table)) continue;
    const t = table as { columns?: unknown[]; rows?: unknown[] };
    if (!Array.isArray(t.columns) || !Array.isArray(t.rows) || t.rows.length === 0) continue;
    return {
      intent: typeof d.intent === 'string' ? d.intent : undefined,
      filters: typeof d.filters === 'object' && d.filters ? (d.filters as Record<string, unknown>) : undefined,
      dataTable: table as AssistantTableExportRequest['dataTable'],
      filenameBase: 'workspace-export',
    };
  }
  return null;
}
